module.exports = __webpack_public_path__ + "img/ad2.ced61832.png";